'use strict';
import Relay from 'system/relay'
import App from 'system/app'

export default {
  props: ['userLabel','userPlaceholder','userIcon'],
  data (){
    const params = Relay.getRedirectParams()
    if(!(params && params.oauth_token)){
      Relay.get("SecureUser",{},function(response){
        this.continue() // we were already logged in
      })
    }
    return {
      auth: {},
      params:params
    }
  },
  methods: {
    login: function(){
      var auth = this.auth
      auth.act = "authenticate"
      auth.dt_ck = "alias,password"
      auth.oauth_token = this.params.oauth_token
      //auth.svc = $stateParams.service // required for SSO
      //auth.tgt = $scope.target_api
      Relay.save("Login",auth,(response)=>{
          this.continue()
        //})
      },
      (err)=>{
        this.$refs.auth_failed.show()
      })
    },

    continue: function(){
      var protected_url = localStorage.getItem("protected_url")
      this.$router.push(protected_url?protected_url:"/")
    }
  }
}
